export default __webpack_public_path__ + "static/media/mode-44.d71c1ddd.svg";